export default {
  getAllEmails(state) {
    return state.allEmails;
  },
};
